import React, { createContext } from 'react'
import PropTypes from 'prop-types'
import { useState } from 'sb-hooks'


const AccordionContext = createContext({})

const Accordion = (props) => {
  const { children } = props

  const [ active, setActive ] = useState(null)

  return (
    <AccordionContext.Provider value={{
      active,
      setActive,
    }}>
      {children}
    </AccordionContext.Provider>
  )
}

Accordion.propTypes = {
  children: PropTypes.node,
}


export { AccordionContext }

export default Accordion
